import { NotFound } from "@dgs/core";
import { FC } from "react";
import { Route, Routes } from "react-router";
import { UserGroupList } from "./UserGroupList";

export const UserGroupsPage: FC = () => {
	return (
		<Routes>
			<Route index element={<UserGroupList />} />
			<Route path="*" element={<NotFound />} />
		</Routes>
	);
};
